//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var BASE_URL = '/prototype/accounting/accounts-receivable/reports';
import { createExport } from '@/mixins/createExport';

export default {
    mixins: [createExport],
    data: function data() {
        return {
            start_date: moment().subtract(1, 'months').format("MM/DD/YYYY"),
            end_date: moment().format("MM/DD/YYYY"),
            bankAccount: false,
            bankAccounts: [],
            checkStatus: null,
            checkStatuses: ['Entered', 'Approved', 'Printed', 'Voided'],
            headers: ['Number', { title: 'Date', filter: 'dateFull' }, 'Account', 'Vendor', { title: 'Amount', filter: 'toCurrency' }, 'Status'],
            fields: ['number', 'created_at', 'account', 'vendor_name', 'amount', 'status'],
            items: [],
            loading: true
        };
    },
    created: function created() {
        var _this = this;

        Event.$on('ar-deposit-register-report', function () {
            _this.$children[0].showModal = true;
            _this.load();
        });

        Event.$on('exportToExcel', function () {
            return _this.exportToExcel();
        });
        Event.$on('exportToPdf', function () {
            return _this.exportToPdf();
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('ar-deposit-register-report');
        Event.$off('exportToExcel');
        Event.$off('exportToPdf');
    },

    methods: {
        exportToExcel: function exportToExcel() {
            this.loading = true;

            var data = {
                exportExcel: true,
                start_date: this.start_date,
                end_date: this.end_date,
                bank_account: this.bankAccount ? this.bankAccount.account_name : null,
                total: this.totalAmount
            };

            this.createExport(data, BASE_URL + '/deposit-register', 'deposit-register', '.xlsx');

            this.loading = false;
        },
        exportToPdf: function exportToPdf() {
            this.loading = true;

            var data = {
                exportExcel: true,
                start_date: this.start_date,
                end_date: this.end_date,
                bank_account: this.bankAccount ? this.bankAccount.account_name : null,
                total: this.totalAmount
            };

            this.createExport(data, BASE_URL + '/deposit-register', 'deposit-register', '.pdf');

            this.loading = false;
        },
        applyFilter: function applyFilter() {
            this.load();
        },
        load: function load() {
            var _this2 = this;

            this.loading = true;

            // load bank accounts
            axios.get('/prototype/accounting/bank-accounts').then(function (response) {
                return _this2.bankAccounts = response.data;
            });

            // build payload
            var data = {
                start_date: this.start_date,
                end_date: this.end_date,
                bank_account: this.bankAccount ? this.bankAccount.account_name : null,
                total: this.totalAmount
            };

            axios.post(BASE_URL + '/deposit-register', data).then(function (response) {
                _this2.items = response.data;
                _this2.loading = false;
            });
        }
    },
    computed: {
        totalAmount: function totalAmount() {
            return Number.parseFloat(this.items.reduce(function (prev, cur) {
                return Number.parseFloat(prev) + Number.parseFloat(cur.total);
            }, 0)).toFixed(2);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/accounts-receivable/reports/ArDepositRegisterReport.vue
// module id = 6IyM
// module chunks = 0 1